import { create } from 'zustand';

interface LoadingStore {
  loading: {
    loadingText: string;
    isLoadingInitial: boolean;
  };
  loadingPage: (loadingText?: string) => void;
  reset: () => void;
}

const defaultState = {
  loading: {
    loadingText: '',
    isLoadingInitial: true,
  },
};

const useLoadingStore = create<LoadingStore>()((set) => ({
  ...defaultState,
  loadingPage: (loadingText = '') => set({ loading: { loadingText, isLoadingInitial: false } }),
  reset: () => set({ ...defaultState }),
}));

export { useLoadingStore };
export type { LoadingStore };
